import * as React from 'react';
import type { Maybe, AdrollSettings } from '@types/gatsby-types';
import { graphql, useStaticQuery, ScriptStrategy } from 'gatsby';
import Script from 'analytics/components/Script';
import { shouldLoadDirectPixel } from 'analytics/lib/dataLayer';

const query = graphql`
    query YelpPixelQuery {
        settings {
            adroll {
                enabled
                advId
                pixelId
            }
        }
    }
`;

type YelpPixelQuery = {
    settings: Maybe<{
        adroll: Maybe<Pick<AdrollSettings, 'advId' | 'pixelId' | 'enabled'>>;
    }>;
};

export default function YelpPixel() {
    const { settings } = useStaticQuery<YelpPixelQuery>(query);
    const advId = settings?.adroll?.advId;
    const pixelId = settings?.adroll?.pixelId;
    const enabled = settings?.adroll?.enabled;

    if (!enabled || !pixelId || !shouldLoadDirectPixel()) {
        return null;
    }

    return (
        <Script
            strategy={ScriptStrategy.idle}
            timeoutMs={2000}
            cookieType="marketing"
            content={`
    adroll_pix_id = "${pixelId}"
    adroll_adv_id = "${advId}"
    adroll_version = "2.0";

    (function(w, d, e, o, a) {
        w.__adroll_loaded = true;
        w.adroll = w.adroll || [];
        w.adroll.f = [ 'setProperties', 'identify', 'track' ];
        var roundtripUrl = "https://s.adroll.com/j/${advId}/roundtrip.js";
        for (a = 0; a < w.adroll.f.length; a++) {
            w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) {
                return function() {
                    w.adroll.push([ n, arguments ])
                }
            })(w.adroll.f[a])
        }

        e = d.createElement('script');
        o = d.getElementsByTagName('script')[0];
        e.async = 1;
        e.src = roundtripUrl;
        o.parentNode.insertBefore(e, o);
    })(window, document);
    adroll.track("pageView");`}
        />
    );
}
